import Vue from 'vue';
import VueRouter from 'vue-router';

import Layout from '@/views/layout';
import Discover from '@/views/discover';
import Comic from '@/views/comic';
import Genres from '@/views/genres';
// import Premium from '@/views/premium';
import PremiumAI from '@/views/premium-ai';
import Chat from '@/views/chat';
import Mine from '@/views/mine';
import Profile from '@/views/profile';
import NovelDetail from '@/views/novelDetail';
import Search from '@/views/search';
import ChapterDetail from '@/views/chapterDetail';
import Wallet from '@/views/wallet';
import Setting from '@/views/setting';
import About from '@/views/about';
// import Feedback from '@/views/feedback';
import TopUp from '@/views/topUp';
import Channel from '@/views/channel';
import ChatRoom from '@/views/chatRoom';
import Character from '@/views/character';
import CharacterDetail from '@/views/characterDetail';
import store from '@/store';
import login, { getAccessToken } from '@/utils/login';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/app/discover',
  },
  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: 'comic',
        name: 'Comic',
        component: Discover,
      },
      {
        path: 'discover',
        name: 'Discover',
        component: Comic,
      },
      {
        path: 'genres',
        name: 'Genres',
        component: Genres,
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
      },

      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
      },
    ],
  },
  {
    path: '/novel/detail/:id',
    name: 'NovelDetail',
    component: NovelDetail,
  },
  {
    path: '/novel/:novelId/chapter/:chapterId',
    name: 'ChapterDetail',
    component: ChapterDetail,
  },
  {
    path: '/novel/search',
    name: 'Search',
    component: Search,
  },
  {
    path: '/mine',
    name: 'Mine',
    component: Mine,
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: Wallet,
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  // {
  //   path: '/feedback',
  //   name: 'Feedback',
  //   component: Feedback,
  // },
  {
    path: '/topup',
    name: 'TopUp',
    component: TopUp,
  },
  {
    path: '/channel/:id',
    name: 'Channel',
    component: Channel,
  },
  {
    path: '/premium',
    name: 'Premium',
    component: PremiumAI,
  },
  {
    path: '/character/:characterId',
    name: 'Character',
    component: Character,
  },
  {
    path: '/chatRoom/:characterId',
    name: 'ChatRoom',
    component: ChatRoom,
  },
  {
    path: '/characterDetail/:characterId',
    name: 'CharacterDetail',
    component: CharacterDetail,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = getAccessToken();
  if (!token) {
    await login();
  }
  const { userInfo } = store.state;
  if (!Object.keys(userInfo).length) {
    store.dispatch('setUserInfo');
  }
  next();
});
export default router;
